import { adminHttpClient } from '../../../commons/adminHttpClient'
import PagedList from '../../../commons/pagedList'
import OrderedPageFilter from '../../../commons/orderedPageFilter'

export type PerksExpenseApprovalResponse = {
  id: string
  firstname: string
  lastname: string
  category: string
  expenseNumber: string
  serviceProvider: string
  createdAt: Date
  serviceDate: Date
  notes: string
  amount: number
  subCategories: string
}

const getPerksExpenseApprovals = (
  planPeriodId: string,
  filter: OrderedPageFilter,
): Promise<PagedList<PerksExpenseApprovalResponse>> => {
  return adminHttpClient.get(`/AdminDashboard/Perks/Reimbursements/GetPerksExpenseApprovals/${planPeriodId}`, filter)
}

export default getPerksExpenseApprovals
